var _path, _path2, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXlIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pdf",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.219,
    height: 40.251,
    viewBox: "0 0 35.219 40.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3220",
    "data-name": "Path 3220",
    d: "M21.845,0H43.219L54.548,11.285v26.45a2.516,2.516,0,0,1-2.516,2.516H21.845a2.516,2.516,0,0,1-2.516-2.516V2.516A2.516,2.516,0,0,1,21.845,0Z",
    transform: "translate(-19.329)",
    fill: "#388e3c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3221",
    "data-name": "Path 3221",
    d: "M214.241,11.488h-8.768a2.516,2.516,0,0,1-2.516-2.516V.193Z",
    transform: "translate(-179.058 -0.168)",
    fill: "#e8f5e9"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "X",
    transform: "translate(12.397 26.523)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlIcon);
export default __webpack_public_path__ + "static/media/xl-icon.43ad33d8c14ce848648cb28b00baeb94.svg";
export { ForwardRef as ReactComponent };